export default "__VITE_PUBLIC_ASSET__7cce3c6c__"